module.exports = __webpack_public_path__ + "img/footer_logo.07bc8ad5.png";